import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setErrorMsg, setSuccessMsg } from "../../actions/Header";
import { useDispatch } from "react-redux";

export const ToastComponent = ({
  message = "",
  // bgColor = "green",
  delay = 5000,
}) => {
  const [msg, setmsg] = useState(message);
  const [bgColor, setBgColor] = useState("green");
  const dispatch = useDispatch();

  const { successMsg, errorMsg } = useSelector((state) => state.HeaderReducer);

  useEffect(() => {
    setmsg(successMsg || errorMsg || message);
    setBgColor("green");
    if (errorMsg) {
      setBgColor("red");
    }
    let closetimer = setTimeout(() => {
      onCloseToast();
      dispatch(setErrorMsg(""));
      dispatch(setSuccessMsg(""));
    }, delay);

    return () => {
      clearTimeout(closetimer);
    };
  }, [message, delay, successMsg, errorMsg]);

  const onCloseToast = () => {
    setmsg(undefined);
  };

  return (
    <>
      {msg && (
        <div
          style={{ backgroundColor: bgColor }}
          className="toast align-items-center text-white border-0 toast-container"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body">{msg} 
            </div>
            <button
              onClick={onCloseToast}
              type="button"
              className="btn-close toast-close"
              aria-label="Close"
            ><span aria-hidden="true" className="succes-delete-btn">×</span></button>
            {/* <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button> */}
          </div>
        </div>
      )}
    </>
  );
};
